// extracted by css-extract-rspack-plugin
export default {"container":"container-Zgz5Hn","grid":"grid-tizqZM","actions":"actions-sTUT5r"};